import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import { errorHandler } from "../../../util/errorHandler";
import moment from "moment";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import MainInput from "../../../component/atoms/input/mainInput";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import ConsultingApi from "../../../api/consulting.api";

const PriorFormDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // ----- 정보 가져오기
  const [formDetail, setFormDetail] = useState({});
  const [editAnswer, setEditAnswer] = useState("");

  useEffect(() => {
    getConsultingInfo();
  }, []);

  const getConsultingInfo = async () => {
    try {
      const response = (await ConsultingApi.getByPriorFormId(id)).data.data.content;

      setFormDetail({ ...response, answer: response.answer || "" });
      setEditAnswer(response.answer || "");
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await ConsultingApi.deleteConsulting(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (!editAnswer?.trim()) {
      return toast(`필수 요소를 전부 입력해주세요.`);
    }
    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        answer: editAnswer.trim(),
      };

      await ConsultingApi.updateAnswer(id, data);
      toast(toastMsg.update);
      setSaveModalOpen(false);
      setFormDetail({ ...formDetail, answer: editAnswer.trim() });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
            </div>
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{formDetail.member?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제출일</DetailFormTitle>
                <DetailFormText>{moment(formDetail.createdAt).format("YYYY/MM/DD")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{formDetail.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>연락처</DetailFormTitle>
                <DetailFormText>{formDetail.phoneNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>생년월일</DetailFormTitle>
                <DetailFormText>{formDetail.birth}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>현재 상황</DetailFormTitle>
                <DetailFormText>{formDetail.currentStatus}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>상담이 필요한 부분</DetailFormTitle>
                <DetailFormText>{formDetail.necessaryPart}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  부동산 및 대출 관련
                  <br />
                  평소 궁금했던 점 3가지
                </DetailFormTitle>
                <DetailFormText>{formDetail.curiousPoint}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>답변하기</DetailPageTitle>
            <DetailPageForm style={{ alignItems: "flex-start" }}>
              <DetailFormTitle>{"답변"}</DetailFormTitle>
              {!formDetail.answer && (
                <MainInput
                  style={{
                    width: "744px",
                  }}
                  type={"text"}
                  placeholder={"내용을 입력해 주세요."}
                  value={editAnswer}
                  onChange={(e) => setEditAnswer(e.target.value)}
                />
              )}
              {formDetail.answer && <DetailFormText>{formDetail.answer}</DetailFormText>}
            </DetailPageForm>
            <div
              style={{ display: "flex", justifyContent: "flex-end" }}
              onClick={
                formDetail.answer === ""
                  ? saveBtnHandler
                  : () => {
                      setFormDetail({ ...formDetail, answer: "" });
                    }
              }
            >
              <SaveBtn
                text={formDetail.answer ? `수정하기` : `답변하기`}
                style={{
                  marginTop: "30px",
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update.title}
          text={modalMsg.update.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default PriorFormDetail;
